import { render } from "./SyncSettingsTab.vue?vue&type=template&id=3cdce80d&scoped=true"
import script from "./SyncSettingsTab.vue?vue&type=script&lang=js"
export * from "./SyncSettingsTab.vue?vue&type=script&lang=js"

import "./SyncSettingsTab.vue?vue&type=style&index=0&id=3cdce80d&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdce80d"]])

export default __exports__